import React, { useState, useEffect } from 'react';
import api from '../../api';     
import config from '../../config';
import { FaInfoCircle, FaUsers, FaSave, FaPlus, FaTrash, FaCheckCircle, FaUserTie } from 'react-icons/fa';
import styles from './Admin.module.css'; // Shared CSS

const AdminAboutSettings = () => {
  const [activeTab, setActiveTab] = useState('general'); // 'general' or 'team'
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });


  // --- STATE 1: General Settings ---
  const [settings, setSettings] = useState({
    storyTitle: '', storyDescription: '',
    visionDescription: '',
    missionPoint1: '', missionPoint2: '', missionPoint3: '', missionPoint4: '',
    engStep1_Title: '', engStep1_Desc: '',
    engStep2_Title: '', engStep2_Desc: '',
    engStep3_Title: '', engStep3_Desc: '',
    engStep4_Title: '', engStep4_Desc: ''
  });

  // --- STATE 2: Team Members ---
  const [team, setTeam] = useState([]);
  const [newLeader, setNewLeader] = useState({
    name: '', position: '', education: '', experience: '', 
    description: '', colorHex: '#1B3F6E', linkedInUrl: '',imageFile: null
  });

  // --- FETCH DATA ---
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
     const [sets, leaders] = await Promise.all([
        api.get('/About/settings'),
        api.get('/About/team')
      ]);
      if (sets.data) setSettings(sets.data);
      if (leaders.data) setTeam(leaders.data);
    } catch (err) {
      console.error("Error loading data", err);
    }
  };

  // ==========================================
  //  LOGIC: GENERAL SETTINGS
  // ==========================================
  const handleSettingChange = (e) => {
    setSettings({ ...settings, [e.target.name]: e.target.value });
  };

  const saveSettings = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ text: '', type: '' });
    
    try {
      const token = localStorage.getItem('token');
    await api.post('/About/settings', settings, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMessage({ text: "Settings Updated!", type: "success" });
    } catch (err) {
      setMessage({ text: "Update Failed", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  // ==========================================
  //  LOGIC: TEAM MANAGEMENT
  // ==========================================
  const handleLeaderChange = (e) => {
    setNewLeader({ ...newLeader, [e.target.name]: e.target.value });
  };

  const handleLeaderFile = (e) => {
    setNewLeader({ ...newLeader, imageFile: e.target.files[0] });
  };

  const addLeader = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    const formData = new FormData();
    Object.keys(newLeader).forEach(key => {
      // ImageFile ko chhodkar baaki sab append karo
      if(key !== 'imageFile' && newLeader[key]) {
        formData.append(key, newLeader[key]);
      }
    });

    // Explicitly append file
    if(newLeader.imageFile) {
      formData.append('ImageFile', newLeader.imageFile);
    }

    try {
      const token = localStorage.getItem('token');
      await api.post('/About/team', formData, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
      });
      
      // Refresh list
      fetchData(); 
      
      // Reset Form completely
      setNewLeader({
        name: '', position: '', education: '', experience: '', 
        description: '', colorHex: '#1B3F6E', imageFile: null
      });

      // 👇 FIX: File Input ko visually clear karne ke liye
      e.target.reset(); 

      setMessage({ text: "Member Added!", type: "success" });
    } catch (err) {
      console.error(err);
      setMessage({ text: "Failed to add member", type: "error" });
    } finally {
      setLoading(false);
    }
  };
  const deleteLeader = async (id) => {
    if (!window.confirm("Are you sure you want to remove this member?")) return;
    
    try {
      const token = localStorage.getItem('token');
     await api.delete(`/About/team/${id}`, {
  headers: { Authorization: `Bearer ${token}` }
});
      fetchData(); // Refresh list
    } catch (err) {
      alert("Failed to delete");
    }
  };

  return (
    <div>
      <div className={styles.formCard} style={{ maxWidth: '1000px' }}>
        
        <h3 style={{ marginBottom: '1.5rem', color: '#4ade80', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <FaInfoCircle /> About Us Management
        </h3>

        {/* --- TABS NAVIGATION --- */}
        <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '10px' }}>
          <button 
            onClick={() => setActiveTab('general')}
            style={{
              background: activeTab === 'general' ? '#4ade80' : 'transparent',
              color: activeTab === 'general' ? '#0f2027' : '#94a3b8',
              border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold'
            }}
          >
            General Text
          </button>
          <button 
            onClick={() => setActiveTab('team')}
            style={{
              background: activeTab === 'team' ? '#4ade80' : 'transparent',
              color: activeTab === 'team' ? '#0f2027' : '#94a3b8',
              border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold'
            }}
          >
            Leadership Team
          </button>
        </div>

        {/* Message Alert */}
        {message.text && (
          <div style={{
            padding: '10px', marginBottom: '20px', borderRadius: '5px',
            background: message.type === 'error' ? 'rgba(239,68,68,0.2)' : 'rgba(74,222,128,0.2)',
            color: message.type === 'error' ? '#fca5a5' : '#4ade80'
          }}>
            {message.text}
          </div>
        )}

        {/* ==================================
            TAB 1: GENERAL SETTINGS
           ================================== */}
        {activeTab === 'general' && (
          <form onSubmit={saveSettings}>
            <h4 style={{color:'#fff', marginBottom:'15px'}}>Company Story</h4>
            <div className={styles.formGroup}>
              <label>Story Title</label>
              <input type="text" name="storyTitle" value={settings.storyTitle} onChange={handleSettingChange} className={styles.formInput} />
            </div>
            <div className={styles.formGroup}>
              <label>Story Description</label>
              <textarea name="storyDescription" value={settings.storyDescription} onChange={handleSettingChange} className={styles.formInput} rows="4" />
            </div>

            <h4 style={{color:'#fff', marginBottom:'15px', marginTop:'20px'}}>Vision & Mission</h4>
            <div className={styles.formGroup}>
              <label>Vision Description</label>
              <textarea name="visionDescription" value={settings.visionDescription} onChange={handleSettingChange} className={styles.formInput} rows="2" />
            </div>
            <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'15px'}}>
              <div className={styles.formGroup}><label>Mission Point 1</label><input type="text" name="missionPoint1" value={settings.missionPoint1} onChange={handleSettingChange} className={styles.formInput} /></div>
              <div className={styles.formGroup}><label>Mission Point 2</label><input type="text" name="missionPoint2" value={settings.missionPoint2} onChange={handleSettingChange} className={styles.formInput} /></div>
              <div className={styles.formGroup}><label>Mission Point 3</label><input type="text" name="missionPoint3" value={settings.missionPoint3} onChange={handleSettingChange} className={styles.formInput} /></div>
              <div className={styles.formGroup}><label>Mission Point 4</label><input type="text" name="missionPoint4" value={settings.missionPoint4} onChange={handleSettingChange} className={styles.formInput} /></div>
            </div>

            <h4 style={{color:'#fff', marginBottom:'15px', marginTop:'20px'}}>Engineering Steps</h4>
            {/* Step 1 & 2 */}
            <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'15px'}}>
                <div>
                    <input type="text" name="engStep1_Title" value={settings.engStep1_Title} onChange={handleSettingChange} className={styles.formInput} placeholder="Step 1 Title" style={{marginBottom:'5px'}} />
                    <input type="text" name="engStep1_Desc" value={settings.engStep1_Desc} onChange={handleSettingChange} className={styles.formInput} placeholder="Step 1 Desc" />
                </div>
                <div>
                    <input type="text" name="engStep2_Title" value={settings.engStep2_Title} onChange={handleSettingChange} className={styles.formInput} placeholder="Step 2 Title" style={{marginBottom:'5px'}} />
                    <input type="text" name="engStep2_Desc" value={settings.engStep2_Desc} onChange={handleSettingChange} className={styles.formInput} placeholder="Step 2 Desc" />
                </div>
            </div>
            {/* Step 3 & 4 */}
            <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'15px', marginTop:'15px'}}>
                <div>
                    <input type="text" name="engStep3_Title" value={settings.engStep3_Title} onChange={handleSettingChange} className={styles.formInput} placeholder="Step 3 Title" style={{marginBottom:'5px'}} />
                    <input type="text" name="engStep3_Desc" value={settings.engStep3_Desc} onChange={handleSettingChange} className={styles.formInput} placeholder="Step 3 Desc" />
                </div>
                <div>
                    <input type="text" name="engStep4_Title" value={settings.engStep4_Title} onChange={handleSettingChange} className={styles.formInput} placeholder="Step 4 Title" style={{marginBottom:'5px'}} />
                    <input type="text" name="engStep4_Desc" value={settings.engStep4_Desc} onChange={handleSettingChange} className={styles.formInput} placeholder="Step 4 Desc" />
                </div>
            </div>

            <button type="submit" className={styles.primaryBtn} disabled={loading} style={{ marginTop: '20px' }}>
              {loading ? 'Saving...' : <><FaSave /> Save General Settings</>}
            </button>
          </form>
        )}

        {/* ==================================
            TAB 2: TEAM MANAGEMENT
           ================================== */}
        {activeTab === 'team' && (
          <div>
            {/* Add New Member Form */}
            <div style={{background:'rgba(255,255,255,0.05)', padding:'20px', borderRadius:'10px', marginBottom:'30px'}}>
              <h4 style={{color:'#4ade80', marginBottom:'15px', display:'flex', alignItems:'center', gap:'8px'}}>
                <FaUserTie /> Add New Team Member
              </h4>
              <form onSubmit={addLeader}>
                <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'15px'}}>
                  <div className={styles.formGroup}>
                    <label>Name</label>
                    <input type="text" name="name" value={newLeader.name} onChange={handleLeaderChange} className={styles.formInput} required />
                  </div>
                  <div className={styles.formGroup}>
                    <label>Position</label>
                    <input type="text" name="position" value={newLeader.position} onChange={handleLeaderChange} className={styles.formInput} required />
                  </div>
                </div>
                <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'15px'}}>
                  <div className={styles.formGroup}>
                    <label>Education</label>
                    <input type="text" name="education" value={newLeader.education} onChange={handleLeaderChange} className={styles.formInput} />
                  </div>
                  <div className={styles.formGroup}>
                    <label>Experience</label>
                    <input type="text" name="experience" value={newLeader.experience} onChange={handleLeaderChange} className={styles.formInput} />
                  </div>
                </div>

                <div className={styles.formGroup}>
                <label>LinkedIn Profile URL</label>
                <input 
                  type="url" 
                  name="linkedInUrl" // Name must match state key
                  value={newLeader.linkedInUrl} 
                  onChange={handleLeaderChange} 
                  className={styles.formInput} 
                  placeholder="https://linkedin.com/in/username"
                />
              </div>
                <div className={styles.formGroup}>
                  <label>Description</label>
                  <textarea name="description" value={newLeader.description} onChange={handleLeaderChange} className={styles.formInput} rows="2" />
                </div>
                
                <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'15px'}}>
                  <div className={styles.formGroup}>
                    <label>Card Color Hex (e.g. #1B3F6E)</label>
                    <input type="color" name="colorHex" value={newLeader.colorHex} onChange={handleLeaderChange} className={styles.formInput} style={{height:'45px', padding:'5px'}} />
                  </div>
                  <div className={styles.formGroup}>
                    <label>Profile Image</label>
                    <input type="file" onChange={handleLeaderFile} className={styles.formInput} accept="image/*" />
                  </div>
                </div>

                <button type="submit" className={styles.primaryBtn} disabled={loading}>
                  {loading ? 'Adding...' : <><FaPlus /> Add Member</>}
                </button>
              </form>
            </div>

            {/* List Existing Members */}
            <h4 style={{color:'#fff', marginBottom:'15px'}}>Current Team ({team.length})</h4>
            <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(250px, 1fr))', gap:'20px'}}>
              {team.map((member) => (
                <div key={member.id} style={{background:'rgba(255,255,255,0.05)', borderRadius:'10px', overflow:'hidden', border:`1px solid ${member.colorHex}`}}>
                  <div style={{background:member.colorHex, padding:'15px', textAlign:'center'}}>
                    {member.imageUrl ? (
                      <img src={`${config.IMG_BASE_URL}${member.imageUrl}`} alt={member.name} style={{width:'60px', height:'60px', borderRadius:'50%', objectFit:'cover', border:'2px solid white'}} />
                    ) : (
                      <div style={{width:'60px', height:'60px', borderRadius:'50%', background:'white', color:member.colorHex, display:'flex', alignItems:'center', justifyContent:'center', fontWeight:'bold', fontSize:'1.5rem', margin:'0 auto'}}>
                        {member.name.charAt(0)}
                      </div>
                    )}
                  </div>
                  <div style={{padding:'15px'}}>
                    <h5 style={{margin:'0 0 5px 0', color:'white'}}>{member.name}</h5>
                    <p style={{margin:0, color:'#94a3b8', fontSize:'0.9rem'}}>{member.position}</p>
                    <button 
                      onClick={() => deleteLeader(member.id)} 
                      style={{marginTop:'15px', width:'100%', padding:'8px', background:'rgba(239,68,68,0.2)', border:'none', color:'#ef4444', borderRadius:'5px', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:'5px'}}
                    >
                      <FaTrash /> Remove
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default AdminAboutSettings;